/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * This component extends standard @angular/material {@link MdTooltip} in order to add some important for grid features:
 * - hiding of component on mouseleave is disabled.
 */
@Directive({
  standalone: false,
  selector: '[ghGridCellTooltip]',
})
export class GridCellTooltipDirective extends MatTooltip {

  @Input('ghGridCellTooltip')
  set cellMessage(message: string) {
    this.message = message;
  }

  hide(delay?: number): void {
    // nothing to do
  }

  forceHide(delay?: number): void {
    super.hide(delay);
  }

}
